<template>
  <div class="topDiv" style="overflow: hidden">
    <el-row style="height: 100%">
      <el-col style="height: 100%" class="leftMenus" :span="4">
        <CompayMenus :menuIndex="menuIndex" />
      </el-col>
      <el-col :span="20" class="setPadding">
        <el-row class="whiteBox"></el-row>
        <div class="mainContent">
          <el-row class="setPageWidth" style="margin-top: -80px">
            <el-col :span="4" class="positionFont" @click.native="speak($event)"
              >职位管理</el-col
            >
            <el-col :span="20" class="setPageWidth">
              <RightMenus />
            </el-col>
          </el-row>
          <div
            class="setPageWidth formContent"
            style="height: 95vh; overflow-y: auto; margin-top: 20px"
          >
            <el-scrollbar style="height: 100%">
              <el-row style="overflow-x: hidden">
                <el-col :span="1" class="viewNumber">1</el-col>
                <el-col :span="22" class="firstDesc">
                  <span style="color: #46cfc1; font-size: 16px"
                    >职位基本信息</span
                  >
                  <span>加 * 内容，在确认发布成功后，将无法修改</span>
                </el-col>
                <el-col :offset="1" :span="22" style="margin-left: 54px">
                  <el-form
                    ref="position"
                    :model="position"
                    :rules="rules"
                    label-width="100px"
                  >
                    <el-form-item label="* 公司名称 ：">
                      <el-input
                        v-model="position.companyName"
                        placeholder="公司名称"
                        :disabled="true"
                        class="inputWidth"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="* 招聘类型 ："
                      prop="cpRecruitmentType"
                    >
                      <el-select
                        v-model="position.cpRecruitmentType"
                        class="inputWidth"
                      >
                        <el-option
                          v-for="item in recruitmentData"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="* 职位名称 ："
                      prop="cpPositionName"
                      class="margintop15"
                    >
                      <el-input
                        v-model="position.cpPositionName"
                        placeholder="职位名称"
                        class="inputWidth"
                      ></el-input>
                    </el-form-item>

                    <el-form-item
                      label="* 职位类型 ："
                      prop="cpJobType"
                      class="margintop15"
                    >
                      <!-- <el-select v-model="position.cpJobType" class="inputWidth">
                        <el-option
                          v-for="item in recruitmentData"
                          :key="item.value"
                          :label="item.label"
                          :value="item.label"
                        ></el-option>
                      </el-select> -->
                      <el-input
                        autocomplete="off"
                        class="inputWidth"
                        placeholder="请选择职位类型"
                        @focus="jobsVisable = true"
                        v-model="position.cpJobType"
                      ></el-input>
                    </el-form-item>

                    <el-form-item
                      label="* 所在区域 ："
                      prop="cpCity"
                      class="margintop15"
                    >
                      <!-- <ChinaData style="width: 500px;" /> -->
                      <el-cascader
                        ref="cas"
                        class="inputWidth"
                        v-model="selectCity"
                        expandTrigger="hover"
                        :props="chinaData"
                        @change="casChange"
                      ></el-cascader>
                    </el-form-item>

                    <el-form-item
                      label="* 工作地点 ："
                      prop="cpWorkAddress"
                      class="margintop15"
                    >
                      <el-input
                        v-model="position.cpWorkAddress"
                        placeholder="工作地点"
                        class="inputWidth"
                      ></el-input>
                      <!-- <el-select
                        v-model="position.cpWorkAddress"
                        placeholder="请选择"
                        class="inputWidth"
                        @change="cityChange"
                      >
                        <el-option
                          v-for="item in cities"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                          <div class="flex-center">
                            <img
                              src="../../assets/pcImage/icon/address.png"
                              style="
                                width: 16px;
                                height: 16px;
                                margin-right: 15px;
                              "
                              alt=""
                            />
                            <span
                              style="
                                float: right;
                                color: #8492a6;
                                font-size: 13px;
                              "
                              >{{ item.label }}</span
                            >
                          </div>
                        </el-option>
                      </el-select> -->
                    </el-form-item>

                    <!-- <el-col
                      :pull="1"
                      :span="1"
                      class="viewNumber"
                      style="margin-top: 20"
                      >2</el-col
                    >
                    <el-col :pull="1" :span="22" class="firstDesc">
                      <span style="color: #46cfc1; font-size: 16px"
                        >职位要求</span
                      >
                      <span
                        >我们将通过以下条件，为您精确推荐合适的应聘者，请尽量详细填写</span
                      >
                    </el-col> -->

                    <el-form-item
                      label="经验学历 ："
                      style=" margin-top: 15px"
                      class="xuelistyle"
                      required
                    >
                      <el-col :span="5">
                        <el-form-item
                          
                          prop="cpJobYears"
                        >
                          <el-select v-model="position.cpJobYears">
                            <el-option
                              v-for="item in jobYears"
                              :key="item.value"
                              :label="item.text"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11">
                        <el-form-item
                          style="margin-left: 5px; text-align: left"
                          prop="cpEducation"
                        >
                          <el-select v-model="position.cpEducation">
                            <el-option
                              v-for="item in selectEducation"
                              :key="item.value"
                              :label="item.text"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-form-item>
                    <el-form-item
                      label="薪资范围 ："
                      
                      required=""
                    >
                      <el-col :span="5">
                        <el-form-item
                         
                          prop="cpMinSalary"
                        >
                          <el-select
                            v-model="position.cpMinSalary"
                            @change="position.cpMaxSalary = null"
                          >
                            <el-option
                              v-for="(item, index) in selectSalary"
                              :key="index + '-min'"
                              :label="item.text"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="10">
                        <el-form-item style="margin-left: 5px">
                          <el-select v-model="position.cpMaxSalary">
                            <el-option
                              v-for="(item, index) in selectSalary"
                              :key="index + '-maxf'"
                              :label="item.text"
                              :value="item.value"
                              v-if="
                                position.cpMinSalary == 'all' ||
                                (position.cpMinSalary < item.value &&
                                  item.value != 'all')
                              "
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-form-item>

                    <!-- <el-form-item
                      label="适合残疾类型 ："
                      label-width="120px"
                      style="margin-left: -15px"
                    >
                      <el-checkbox-group v-model="selectDamagedArea">
                        <el-checkbox
                          v-for="area in damagedArea"
                          :label="area.text"
                          :key="area.value"
                          :name="area.text"
                        ></el-checkbox>
                      </el-checkbox-group>
                    </el-form-item> -->

                    <!-- <el-form-item label="受损等级 ：" prop="cpDamagedLevel">
                      <el-select
                        v-model="position.cpDamagedLevel"
                        class="inputWidth"
                      >
                        <el-option
                          v-for="item in damagedLevel"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item> -->

                    <el-form-item
                      label="就业类型 ："
                      prop="cpFormsOfEmployment"
                      style="height: 48px"
                      class="margintop15"
                    >
                      <!-- <el-radio v-model="position.cpFormsOfEmployment" label="1" border>居家就业</el-radio> -->
                      <el-radio
                        v-model="position.cpFormsOfEmployment"
                        v-for="item in formsOfEmployment"
                        :key="item.value"
                        :label="item.value"
                        border
                        >{{ item.text }}</el-radio
                      >
                    </el-form-item>

                    <el-form-item label="职位描述 ：">
                      <el-input
                        type="textarea"
                        placeholder="请输入职位描述"
                        :rows="10"
                        maxlength="5000"
                        show-word-limit
                        v-model="position.cpPositionDesc"
                        style="width: 850px"
                      ></el-input>
                    </el-form-item>

                    <el-form-item label="岗位要求 ：">
                      <el-input
                        type="textarea"
                        placeholder="请输入岗位要求"
                        :rows="10"
                        maxlength="5000"
                        show-word-limit
                        v-model="position.cpPositionRequirement"
                        style="width: 850px"
                      ></el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col
                  style="margin-left: 150px; font-size: 14px; line-height: 22px"
                  >简历将发送到 13133333333333@163.com，如需更改邮箱，请在『
                  我的资料』 中修改</el-col
                >
                <el-col
                  style="margin-left: 150px; font-size: 14px; line-height: 70px"
                  :span="9"
                >
                  <span>已阅读并遵守《彩虹家园职位信息发布规则》</span>
                </el-col>
                <el-col
                  :span="2"
                  class="submitFrom"
                  @click.native="submitForm('position')"
                  >发布</el-col
                >
              </el-row>

              <el-row style="margin-top: 40px"></el-row>
            </el-scrollbar>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="添加新的工作地点"
      :visible.sync="dialogVisible"
      width="40%"
      :show-close="false"
      custom-class="ziZhidialog"
      :before-close="handleClose"
      label-position="left"
    >
      <AddAddressPos
        :location="cityLabel"
        @selectItem="selectItemHandler"
        @isShow="visiableHandler"
      />
    </el-dialog>
    <el-dialog
      custom-class="dialogJobs"
      title="选择职位类别"
      :visible.sync="jobsVisable"
      top="0vh"
      show-close
      width="900px"
    >
      <JobsCategoryComp @selectValue="selectJobsValue" />
    </el-dialog>
  </div>
</template>
<script>
import RightMenus from "@/components/company/RightMenus.vue";
import CompayMenus from "@/components/company/CompayMenus.vue";
import { ajaxGetDictItems } from "@/comm/api";
import { getAction, postAction } from "@/comm/manage";
import ChinaData from "@/components/ChinaData.vue";
import Vue from "vue";
import AddAddressPos from "@/components/company/AddAddressPos.vue";
import JobsCategoryComp from "@/components/JobsCategoryComp.vue";
import { login } from "@/comm/api";

export default {
  name: "",
  components: {
    RightMenus,
    CompayMenus,
    ChinaData,
    AddAddressPos,
    JobsCategoryComp,
  },

  props: {},

  data() {
    return {
      cities: [
        {
          value: "-1",
          label: "添加新的工作地点",
        },
      ],
      cityLabel: "",
      jobsVisable: false,
      dialogVisible: false,
      menuIndex: 1,
      sreachValue: "",
      recruitmentData: [],
      selectSalary: "",
      jobYears: [],
      selectEducation: [],
      damagedArea: [],
      selectDamagedArea: [],
      damagedLevel: [],
      formsOfEmployment: [],
      selectCity: "",
      companyInfo: null,

      position: {
        companyName: "",
        cpPositionType: "",
        cpPositionName: "",
        cpWorkAddress: "",
        cpJobType: "",
        cpProvince: "",
        cpCity: "",
        cpCounty: "",
        cpJobYears: "",
        cpEducation: "",
        cpDamagedArea: null,
        cpDamagedLevel: "",
        cpFormsOfEmployment: "",
        cpPositionDesc: "",
        cpPositionRequirement: "",
        cpComId: null,
        cpMinSalary:null,
        cpMaxSalary:null,
      },
      rules: {
        cpPositionName: [
          { required: true, message: "请输入职位名称", trigger: "blur" },
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        cpRecruitmentType: [
          { required: true, message: "请选择招聘类型", trigger: "change" },
        ],
        cpJobType: [
          { required: true, message: "请选择职位类型", trigger: "change" },
        ],
        cpWorkAddress: [
          { required: true, message: "请输入工作地点", trigger: "change" },
        ],
        cpCity: [
          { required: true, message: "请输入所在城市", trigger: "change" },
        ],
        cpJobYears: [
          { required: true, message: "请选择经验", trigger: "change" },
        ],
        cpEducation: [
          { required: true, message: "请选择学历", trigger: "change" },
        ],
        cpMinSalary: [
          { required: true, message: "请选择最低薪资", trigger: "change" },
        ],
        cpMaxSalary: [
          { required: true, message: "请选择最高薪资", trigger: "change" },
        ],
        cpDamagedLevel: [
          { required: true, message: "请选择受损等级", trigger: "change" },
        ],
        cpFormsOfEmployment: [
          { required: true, message: "请选择就业类型", trigger: "change" },
        ],
      },
      chinaData: {
        lazy: true,
        lazyLoad(node, resolve) {
          var params = {
            pageSize: 1000,
          };
          if (node.root) {
            params.deep = 0;
          } else {
            params.pid = node.data.value;
          }
          getAction("/chinadata/tsChinaDataLeave/list", params).then((res) => {
            if (res.success) {
              const nodes = res.result.records.map((item) => ({
                value: item.cid,
                label: item.name,
                leaf: item.cid.length > 6,
              }));
              resolve(nodes);
            }
            if (res.code === 510) {
              this.$message.warning(res.message);
            }
          });

          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        },
      },
    };
  },
  created: function () {
    this.initDictData("recruitmentType", "recruitmentData");
    this.initDictData("workExperience", "jobYears");
    this.initDictData("education", "selectEducation");
    this.initDictData("selectSalary", "selectSalary");
    this.initDictData("damagedArea", "damagedArea");
    this.initDictData("damagedLevel", "damagedLevel");
    this.initDictData("formsOfEmployment", "formsOfEmployment");
    this.$store.dispatch("setIsShowHead", false);
    this.userInfo = this.$store.state.users.userInfo;

    if (this.$store.state.sys_dicts.categories.length == 0)
      this.$store.dispatch("loadCategories");

    if (this.$route.params.positionMsg) {
      this.position = this.$route.params.positionMsg;
      this.position.companyName = this.userInfo.ucComName;
      this.selectDamagedArea = this.position.cpDamagedArea.split(",");
      this.selectCity = this.position.cpArea.split(",");
    }
    this.getCompanyInfo();
  },
  // mounted () { //这个属性就可以，在里面声明初始化时要调用的方法即可
  //     // we can implement any method here like
  //     this.getUsers()
  //   },
  methods: {
    getUUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    handleChange(value) {
      console.log(value);
    },
    getCompanyInfo() {
      let that = this;
      if (!that.companyInfo) {
        getAction("/company/tsCompany/queryById", {
          id: that.userInfo.ucComId,
        }).then((res) => {
          if (res.success) {
            that.companyInfo = res.result;
            that.position.companyName = that.companyInfo.comName;

            that.position.cpComId = that.companyInfo.comId;
          } else {
            that.$message.error(res.message);
          }
        });
      } else {
        that.position.companyName = that.companyInfo.comName;
        that.position.cpComId = that.companyInfo.comId;
      }
    },
    submitForm(formName) {
      // let str = "";
      // this.$refs.cas.getCheckedNodes()[0].pathLabels.map(item => {
      //   str += item;
      // })
      this.$refs.position.validate((valid) => {
        if (valid) {
          let userInfo = this.$store.state.users.userInfo;
          if (userInfo && userInfo.userType == "company") {
            this.position.cpHrId = userInfo.ucId;
            this.position.cpHr = userInfo.ucUsername;
            this.position.cpHrPhone = userInfo.ucPhone;
          }
          if (this.selectCity != "")
            this.position.cpArea = this.selectCity.join(",");
          // if (this.selectDamagedArea.length > 0) {
          //   this.position.cpDamagedArea = this.selectDamagedArea.join(",");
          // } else {
          //   this.$message.error("请选择适合的残疾类型");
          //   return;
          // }
          console.log("position=", this.position);
          postAction("/position/tsCompanyPosition/add", this.position).then(
            (res) => {
              if (res.success) {
                // resolve();
                console.log(res);
                this.$message.success("职位发布成功");
                this.$router.push("/pcCompanyHome");
              } else {
                console.log(res);
                this.$message.error("职位发布异常");
                // this.$message.error(res.message);
                // reject();
              }
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    initDictData(dictCode, name) {
      // //优先从缓存中读取字典配置
      // if (getDictItemsFromCache(this.dictCode)) {
      //   this.dictOptions = getDictItemsFromCache(this.dictCode);
      //   return;
      // }

      //根据字典Code, 初始化字典数组

      ajaxGetDictItems(dictCode, null).then((res) => {
        if (res.success) {
          //                console.log(res.result);
          this[name] = res.result;
          if (dictCode == "formsOfEmployment") {
            this[name] = res.result.filter((item) => {
              return item.text != "不限";
            });
            console.log(this[name]);
          }
        }
      });
    },
    getChinaData(code) {
      //deep 1 查询所有市
      postAction("/chinadata/tsChinaDataLeave/list", pramams).then((res) => {
        if (res.success) {
          // resolve();
          console.log(res);
          this.$message.success("职位发布成功");
        } else {
          console.log(res);
          this.$message.error("职位发布异常");
          // this.$message.error(res.message);
          // reject();
        }
      });
    },
    cityChange(val) {
      if (this.selectCity == "") {
        this.$message.error("请先选择工作城市");
        this.position.cpWorkAddress = "";
      } else {
        if (val == -1) {
          this.dialogVisible = true;
        }
      }
    },
    handleClose(done) {
      this.dialogVisible = false;
    },
    casChange(val) {
      if (val) {
        let str = "";
        this.$refs.cas.getCheckedNodes()[0].pathLabels.map((item) => {
          str += item;
        });
        this.cityLabel = this.$refs.cas.getCheckedNodes()[0].pathLabels[1];
        this.position.cpProvince = val[1];
        this.position.cpCity = val[2];
        this.position.cpCounty = val[3];

        //冗余字段，方便快捷显示区域信息
        this.position.cpProvinceLabel = this.$refs.cas.getCheckedNodes()[0].pathLabels[1];
        this.position.cpCityLabel = this.$refs.cas.getCheckedNodes()[0].pathLabels[2];
        this.position.cpCountyLabel = this.$refs.cas.getCheckedNodes()[0].pathLabels[3];
      }
    },
    selectItemHandler(item, val) {
      if (item.address) {
        this.position.cpWorkAddress = item.address + " " + val;
        this.position.lng = item.point.lng;
        this.position.lat = item.point.lat;
      } else {
        this.position.cpWorkAddress = "";
      }
    },
    visiableHandler(val) {
      this.dialogVisible = false;
    },
    selectJobsValue(val) {
      this.position.cpJobType = val;
      this.jobsVisable = false;
    },
    speak(e) {
      this.handleSpeak(e.target.innerHTML);
    },
    // 语音播报的函数
    handleSpeak(text) {
      msg.text = text; // 文字内容: 小朋友，你是否有很多问号
      msg.lang = "zh-CN"; // 使用的语言:中文
      msg.volume = 1; // 声音音量：1
      msg.rate = 1; // 语速：1
      msg.pitch = 1; // 音高：1
      synth.speak(msg); // 播放
    },
  },
};
</script>
<style lang="stylus" scoped>
.flex-center {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.topDiv {
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  height: 100%;
  background-color: #F0F2F5;
  margin: 0 auto;

  .setPadding {
    padding: 0 0 0 260px;
    width: 100%;
  }

  >>>.el-cascader {
    display: inline-block;
    position: relative;
    font-size: 14px;
    line-height: 40px;
    width: 500px;
  }

  .el-form-item.is-required:not(.is-no-asterisk), .el-form-item__label-wrap>.el-form-item__label:before, >>>.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
    content: none;
    color: #F56C6C;
    margin-right: 4px;
  }

  .viewNumber {
    font-size: 40px;
    color: #46cfc1;
    text-align: center;
    width: 60px;
  }

  .submitFrom {
    background-color: #5dd5c8;
    color: #fff;
    font-size: 14px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    width: 80px;
    border: 1px solid #5dd5c8;
    margin-top: 20px;
    cursor: pointer;
  }

  .inputWidth {
    width: 500px;
  }

  >>>.el-input__inner {
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 32px;
    line-height: 32px;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
  }

  >>>.el-form-item__label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 32px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }

  >>>.el-form-item {
    margin-bottom: 12px;
  }

  .formContent {
    background-color: #fff;
    margin-top: 20px;
    min-height: 500px;
    min-width: 860px;

    >>>.el-form-item__label {
      text-align: right;
      vertical-align: middle;
      float: left;
      font-size: 14px;
      color: #9fa3b0;
      line-height: 40px;
      padding: 0 12px 0 0;
      box-sizing: border-box;
    }
  }

  // >>>.el-radio__inner { // 去除radio的小圆圈
  // border-color: none;
  // background: none;
  // border: none;
  // border-radius: 100%;
  // width: 14px;
  // height: 14px;
  // background-color: #FFF;
  // cursor: pointer;
  // box-sizing: border-box;
  // }
  >>>.el-radio.is-bordered {
    padding: 8px 15px 0 10px;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    height: 32px;
  }

  .firstDesc {
    font-size: 14px;
    margin-top: 10px;

    span {
      display: block;
      font-size: 12px;
      line-height: 20px;
      color: #9fa3b0;
      margin-bottom: 10px;
      width: 260px;
    }
  }

  .whiteBox {
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    background: #fff;
    height: 64px;
  }

  .positionFont {
    height: 64px;
    line-height: 64px;
    color: #000;
  }

  .leftMenus {
    position: fixed;
    width: 256px;
    height: 100%;
    top: 0;
    z-index: 100;
    box-shadow: 1px 0 5px rgba(0, 0, 0, 0.05);
    background: #252830;
  }

  .setPageWidth {
    max-width: 1180px;
    margin: 0 auto;

    .pulishJob {
      width: 88px;
      height: 32px;
      background: #f82b18;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 32px;
      text-align: center;
      margin-top: 20px;
    }

    .marginTopButton {
      margin: 10px 0 11px 0;
    }
  }

  .margintop15 {
    margin-top: 15px;
  }

  .mainContent {
    padding: 15px 40px 15px 40px;
    height: 100%;
    position: relative;
    width: 100%;
    font-size: 18px;
    line-height: 64px;
    text-align: left;
  }
}
</style>